module.exports = __webpack_public_path__ + "img/pen-slash.39c80e7a.svg";